import React, { useState } from "react";
import Section from "../components/Section";
import RecomendacionCard from "../components/RecomendacionCard";
import { useCollection } from "../hooks/useCollection";

const Recomendaciones = () => {
  const { docs: recomendaciones, loading } = useCollection('recomendaciones');
  const [paginaActual, setPaginaActual] = useState(1);
  const porPagina = 6;

  const totalPaginas = Math.ceil(recomendaciones.length / porPagina);

  const cambiarPagina = (nuevaPagina) => {
    setPaginaActual(nuevaPagina);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const pagina = recomendaciones.slice(
    (paginaActual - 1) * porPagina,
    paginaActual * porPagina
  );

  return (
    <Section title="Recomendaciones">
      {loading ? (
        <p>Cargando...</p>
      ) : (
        <>
          <div className="card-grid">
            {pagina.map((recomendacion, i) => (
              <RecomendacionCard key={i} recomendacion={recomendacion} />
            ))}
          </div>

          {totalPaginas > 1 && (
            <div className="pagination">
              <button disabled={paginaActual === 1} onClick={() => cambiarPagina(paginaActual - 1)}>
                Anterior
              </button>
              {Array.from({ length: totalPaginas }, (_, i) => (
                <button
                  key={i + 1}
                  className={paginaActual === i + 1 ? "active" : ""}
                  onClick={() => cambiarPagina(i + 1)}
                >
                  {i + 1}
                </button>
              ))}
              <button disabled={paginaActual === totalPaginas} onClick={() => cambiarPagina(paginaActual + 1)}>
                Siguiente
              </button>
            </div>
          )}
        </>
      )}
    </Section>
  );
};

export default Recomendaciones;
